import React, {Component} from 'react'
import { DropdownToggle, ButtonDropdown, DropdownMenu, DropdownItem } from 'reactstrap'
import {addNewTabSku} from '../../../services/api/apiSku'
import {message} from "antd"
import PubSub from "pubsub-js"

class SkuAddBrand extends Component {
    state = {
        dropdownOpen: false,
        selectedBrand: '',
        loading: false,
    }

    _toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    _setSelectedBrand = (value) => {
        this.setState({
            selectedBrand: value
        }, () => {
            this._actionAddBrand()
        })
    }

    _actionAddBrand = async () => {
        this.setState({
            loading: true
        })

        try {
            const {skuID} = this.props
            const {selectedBrand} = this.state

            const {data} = await addNewTabSku(skuID, 'brand', selectedBrand)
            const {success, message: messApi} = data

            if(!success) return this.setState({
                loading: false
            }, () => {
                message.error(messApi)
            })

            message.success('Thêm mới brand thành công!')
            PubSub.publish('GET_LIST_TAB')

            this.setState({
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false
            }, () => {
                message.error(e.message)
            })
        }
    }

    render() {
        const {brandOptions, listTab} = this.props
        const {loading} = this.state
        const listBrandActive = listTab.filter(item => item.type === 'brand').map(item => item.name)

        return (
            <div className="SkuAddCarrier mb-3 mr-2 d-flex justify-content-end">
                <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this._toggle}>
                    <DropdownToggle disabled={loading} caret color="primary">
                        Thêm Brand
                    </DropdownToggle>
                    <DropdownMenu right={true}>
                        {
                            brandOptions.map((option, index) => {

                                const {name, value} = option

                                return (value !== '' &&
                                    <DropdownItem disabled={listBrandActive.includes(value)} key={index} onClick={() => this._setSelectedBrand(value)}>{name}</DropdownItem>)
                            })
                        }
                    </DropdownMenu>
                </ButtonDropdown>
            </div>
        )
    }
}

SkuAddBrand.propTypes = {

}

export default SkuAddBrand